import { setCookie, removeCookie } from '../utils/cookieUtils';
import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from './endpoints';

// 로그인 처리
export const authLogin = async (username: string, password: string) => {
    // 실제 로그인 로직 (서버 요청 등)
    try {
        const response = await axiosInstance.post(`${API_ENDPOINTS.auth}/login`, { username, password });
        return response.data;
    } catch (error: any) {
        //throw new Error(error.response?.data?.message || "로그인에 실패하셨습니다.")
        console.log(error, "로그인 실패!")
    }
};

// 로그아웃 처리
export const logoutUser = () => {
    removeCookie('accessToken'); // 쿠키에서 인증 상태 삭제
};